export interface ValidationOptions {
  accept?: string[];
  maxSizeInBytes?: number;
}

export const validateFile = (file: File, options: ValidationOptions): void => {
  const { accept, maxSizeInBytes } = options;

  if (accept && accept.length > 0) {
    const fileName = file.name.toLowerCase();
    const fileType = file.type.toLowerCase();
    const fileExtension = "." + fileName.split(".").pop();

    const isAllowed = accept.some((type) => {
      const cleanType = type.trim().toLowerCase();
      // Check against extension (e.g. ".jpg")
      if (cleanType.startsWith(".")) {
        return fileName.endsWith(cleanType);
      }
      // Check against MIME type (e.g. "image/png")
      // If the file.type matches exactly
      if (fileType === cleanType) {
        return true;
      }
      return false;
    });

    if (!isAllowed) {
      // Create a readable list of allowed types for the error message
      const allowedList = accept.join(", ");
      throw new Error(
        `File type not allowed. Allowed types: ${allowedList}. Got: ${
          fileType || fileExtension
        }`
      );
    }
  }

  if (maxSizeInBytes && file.size > maxSizeInBytes) {
    const maxSizeMB = Math.round(maxSizeInBytes / (1024 * 1024));
    throw new Error(`File size must be less than ${maxSizeMB}MB`);
  }
};
